<div class="loading"></div>
<router-outlet></router-outlet>
